"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Gabe Kelley (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=8944%3A1597))
 * @trackcomponent
 * @lastsynced 2025-07-07T16:19:10.683Z
 */
export const Slovakia = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2V14H17V2H1Z"
      fill="#3D58DB"
    />
    <mask
      id="mask0_8944_1597"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="2"
      width="16"
      height="12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2V14H17V2H1Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_8944_1597)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2V6H17V2H1Z"
        fill="#F7FCFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 10V14H17V10H1Z"
        fill="#E31D1C"
      />
      <path
        d="M8.80214 5.015L9.05064 4.9885L9.02714 4.765H3.93914L3.92314 4.9985V5.0005L3.92264 5.0065L3.92114 5.0295L3.91564 5.1175C3.88696 5.56523 3.86313 6.01326 3.84414 6.4615C3.81214 7.2315 3.79064 8.1325 3.84664 8.5535C3.95564 9.3745 4.45614 11.2185 6.39014 12.0535L6.49114 12.097L6.59114 12.052C8.42864 11.231 9.04264 9.577 9.18464 8.5545C9.25614 8.039 9.21964 7.1365 9.16964 6.3865C9.13864 5.92971 9.09997 5.47348 9.05364 5.018L9.05164 4.9965L9.05114 4.9905V4.989L8.80214 5.015Z"
        fill="#E31D1C"
      />
      <path
        d="M3.92314 4.9985L3.93914 4.765H9.02714L9.05064 4.9885L8.80214 5.015L9.05114 4.989V4.9905L9.05164 4.9965L9.05364 5.018C9.09997 5.47348 9.13864 5.92971 9.16964 6.3865C9.21964 7.1365 9.25614 8.039 9.18464 8.5545C9.04264 9.577 8.42864 11.231 6.59114 12.052L6.49114 12.097L6.39014 12.0535C4.45614 11.2185 3.95564 9.3745 3.84664 8.5535C3.79064 8.1325 3.81214 7.2315 3.84414 6.4615C3.86313 6.01326 3.88696 5.56523 3.91564 5.1175L3.92114 5.0295L3.92264 5.0065L3.92314 5.0005V4.9985ZM3.92314 4.9985L4.17264 5.015"
        stroke="white"
        strokeWidth="0.5"
      />
      <mask
        id="mask1_8944_1597"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="4"
        width="7"
        height="9"
      >
        <path
          d="M8.80214 5.015L9.05064 4.9885L9.02714 4.765H3.93914L3.92314 4.9985V5.0005L3.92264 5.0065L3.92114 5.0295L3.91564 5.1175C3.88696 5.56523 3.86313 6.01326 3.84414 6.4615C3.81214 7.2315 3.79064 8.1325 3.84664 8.5535C3.95564 9.3745 4.45614 11.2185 6.39014 12.0535L6.49114 12.097L6.59114 12.052C8.42864 11.231 9.04264 9.577 9.18464 8.5545C9.25614 8.039 9.21964 7.1365 9.16964 6.3865C9.13864 5.92971 9.09997 5.47348 9.05364 5.018L9.05164 4.9965L9.05114 4.9905V4.989L8.80214 5.015Z"
          fill="white"
        />
        <path
          d="M3.92314 4.9985L3.93914 4.765H9.02714L9.05064 4.9885L8.80214 5.015L9.05114 4.989V4.9905L9.05164 4.9965L9.05364 5.018C9.09997 5.47348 9.13864 5.92971 9.16964 6.3865C9.21964 7.1365 9.25614 8.039 9.18464 8.5545C9.04264 9.577 8.42864 11.231 6.59114 12.052L6.49114 12.097L6.39014 12.0535C4.45614 11.2185 3.95564 9.3745 3.84664 8.5535C3.79064 8.1325 3.81214 7.2315 3.84414 6.4615C3.86313 6.01326 3.88696 5.56523 3.91564 5.1175L3.92114 5.0295L3.92264 5.0065L3.92314 5.0005V4.9985ZM3.92314 4.9985L4.17264 5.015"
          stroke="white"
          strokeWidth="0.5"
        />
      </mask>
      <g mask="url(#mask1_8944_1597)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.12849 5.295C6.12849 5.295 6.23199 5.4525 6.27799 5.693C6.32449 5.933 6.33199 6.355 6.33199 6.355L5.35299 6.234V6.977L6.35399 6.8495L6.33799 7.5545C6.33799 7.5545 6.03799 7.5855 5.79299 7.5545C5.54699 7.523 5.06299 7.393 5.06299 7.393V8.243C5.06299 8.243 5.55449 8.086 5.79299 8.05C6.03049 8.0135 6.33799 8.05 6.33799 8.05V9.094H6.74449V8.05C6.74449 8.05 7.18849 8.011 7.45399 8.053C7.71899 8.095 7.97049 8.243 7.97049 8.243V7.393C7.97049 7.393 7.71549 7.52 7.47549 7.5515C7.23549 7.583 6.74449 7.554 6.74449 7.554L6.76049 6.849C6.76049 6.849 7.09299 6.815 7.27999 6.84C7.46649 6.8655 7.69999 6.977 7.69999 6.977V6.234C7.69999 6.234 7.47249 6.358 7.29299 6.3805C7.11399 6.403 6.73849 6.355 6.73849 6.355C6.73849 6.355 6.74549 5.92 6.78349 5.708C6.82249 5.4965 6.93149 5.295 6.93149 5.295H6.12849Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.44873 10.1225C4.44873 10.1225 4.66873 9.65099 5.02623 9.56149C5.38373 9.47149 5.75873 9.84149 5.75873 9.84149C5.75873 9.84149 5.98773 9.09399 6.54573 9.09399C7.10373 9.09399 7.29973 9.84199 7.29973 9.84199C7.29973 9.84199 7.53773 9.56149 7.87973 9.56149C8.22273 9.56149 8.53973 10.1225 8.53973 10.1225C8.53973 10.1225 7.51723 11.9795 6.49473 11.9795C5.47173 11.9795 4.44873 10.1225 4.44873 10.1225Z"
          fill="#2E42A5"
        />
      </g>
    </g>
    <rect x="1" y="2" width="16" height="12" stroke="#757575" />
  </>,
  "Slovakia",
  { fill: "none", viewBox: "0 0 18 16" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
